// Servicio de clientes del panel (spec panel-atencion §4). IO PostgREST, sin
// React. La ficha se resuelve con el select anidado de PostgREST (policy
// SELECT sobre la réplica), NO con la Edge Function lookup-cliente (exclusiva
// del bot) ni RPC.
//
// Dos criterios OPUESTOS sobre `activo`, y es a propósito:
//   - el CLIENTE no se filtra: su ficha se ve aunque esté archivado (auditoría,
//     spec §8);
//   - sus EQUIPOS sí. En Odoo los equipos nunca se borran, solo pasan a estado
//     `blocked` cuando se sustituyen, y el sync los marca `activo = false`.
//     Manuel lo pidió expresamente el 3-sep viendo esta misma pantalla: "los
//     bloqueados ya no tiene sentido que aparezcan". Sin este filtro, MERCADO
//     CENTRAL enseñaba sus 5 mesas retiradas junto a las 5 en uso, con nombres
//     casi idénticos.
// El filtro va en el embebido y no con `!inner`, para que un cliente sin
// equipos activos siga devolviendo ficha (con la lista vacía) en vez de nada.

import { supabase } from '../lib/supabase';
import type { FichaCliente } from '../types/clientes';

// Columnas exactas de los tipos espejo (sin arrastrar campos de sync).
const COLUMNAS_FICHA =
  'id, id_odoo, razon_social, cif, direccion, poblacion, provincia, ' +
  'fuera_de_radio, bloqueado, tiene_contrato, tipo_contrato, ' +
  'comercial_aramatica, comercial_siwell, activo, archivado_en, ' +
  'telefonos:telefonos_replica(telefono, origen), ' +
  'equipos:equipos_replica(referencia, tipo, descripcion, ubicacion, direccion_instal, tiene_ficha, activo)';

// Ficha completa por id (uuid de clientes_replica). null si no existe.
export async function fetchFichaCliente(idCliente: string): Promise<FichaCliente | null> {
  const { data, error } = await supabase
    .from('clientes_replica')
    .select(COLUMNAS_FICHA)
    .eq('id', idCliente)
    .eq('equipos.activo', true)
    .maybeSingle();

  if (error) {
    console.error(
      JSON.stringify({ evt: 'fetch_ficha_failed', code: error.code, message: error.message })
    );
    throw new Error(`No pude cargar la ficha del cliente: ${error.message}`);
  }
  return data as unknown as FichaCliente | null;
}
